import {
  SegmentForslag,
  SegmenterPerBransje,
} from 'services/KjederegisteretAdminApi/SegmentApi/types';

export const getSegmenterForBransje = (
  segmenter: SegmenterPerBransje | undefined,
  bransjeId: number | undefined,
): string[] => (bransjeId !== undefined && segmenter?.[bransjeId]) || [];

/** Forslaget vises bare når det peker på et gyldig segment. */
export const getVisibleForslag = (
  forslag: SegmentForslag | undefined,
  tilgjengelige: string[],
): SegmentForslag | undefined =>
  forslag?.segment && tilgjengelige.includes(forslag.segment) ? forslag : undefined;

/** Segmentet skal nullstilles når det ikke lenger er gyldig for valgt bransje. */
export const shouldClearSegment = (
  segmenter: SegmenterPerBransje | undefined,
  bransjeId: number | undefined,
  valgt: string | null | undefined,
): boolean =>
  !!segmenter && !!valgt && !getSegmenterForBransje(segmenter, bransjeId).includes(valgt);
